'use client'

// Third-party Imports
import PerfectScrollbar from 'react-perfect-scrollbar'
import type { ScrollBarProps } from 'react-perfect-scrollbar'

const ReactPerfectScrollbar = (props: ScrollBarProps) => {
  return <PerfectScrollbar {...props} />
}

export default ReactPerfectScrollbar
